import { FormlyFieldConfig } from '@ngx-formly/core';

export function maxLengthValidatorMessage(error: unknown, field: FormlyFieldConfig): string {
  return `This value must be less than ${field.props?.maxLength} characters`;
}
